import { ShippingRateFe } from "@intelligems/ig-types";

/** Flat Rate with Threshold stores the paid rate before the free one. */
export const orderFlatThresholdRate = (
  rateA: ShippingRateFe,
  rateB: ShippingRateFe
) => {
  if (rateA.rateType === "threshold") {
    return 1;
  }
  return -1;
};
